"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipSortByEnum = exports.OrganizationUserOrderBy = exports.UserOrderBy = exports.EmployeeStatus = void 0;
var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["ACTIVE"] = "active";
    EmployeeStatus["INACTIVE"] = "inactive";
    EmployeeStatus["PENDING"] = "pending";
})(EmployeeStatus = exports.EmployeeStatus || (exports.EmployeeStatus = {}));
var UserOrderBy;
(function (UserOrderBy) {
    UserOrderBy["EMAIL"] = "email";
    UserOrderBy["FIRST_NAME"] = "firstName";
    UserOrderBy["LAST_NAME"] = "lastName";
    UserOrderBy["LAST_LOGIN"] = "lastLogin";
})(UserOrderBy = exports.UserOrderBy || (exports.UserOrderBy = {}));
var OrganizationUserOrderBy;
(function (OrganizationUserOrderBy) {
    OrganizationUserOrderBy["STATUS"] = "status";
    OrganizationUserOrderBy["EMPLOYMENT_START_DATE"] = "employmentStartDate";
    OrganizationUserOrderBy["EMPLOYMENT_END_DATE"] = "employmentEndDate";
    OrganizationUserOrderBy["REFERENCE_ID"] = "referenceId";
})(OrganizationUserOrderBy = exports.OrganizationUserOrderBy || (exports.OrganizationUserOrderBy = {}));
var MembershipSortByEnum;
(function (MembershipSortByEnum) {
    MembershipSortByEnum["NAME"] = "name";
    MembershipSortByEnum["CUSTOMER_TYPES"] = "customerTypes";
    MembershipSortByEnum["RENWAL"] = "renewal";
    MembershipSortByEnum["GENDER"] = "gender";
    MembershipSortByEnum["ACTIVITIES"] = "activities";
    MembershipSortByEnum["MEMEMBERSHIP_TYPE"] = "membershipType";
})(MembershipSortByEnum = exports.MembershipSortByEnum || (exports.MembershipSortByEnum = {}));
//# sourceMappingURL=enums.js.map